export default {
  data () {
    return {
      showPassword: false
    }
  },

  computed: {
    passwordShowStr () {
      return this.showPassword ? 'Hide' : 'Show'
    },

    passwordType () {
      return this.showPassword ? 'text' : 'password'
    }
  },

  methods: {
    toggleShowPassword () {
      this.showPassword = !this.showPassword
    }
  },

  watch: {
    password: function (newPassword) {
      this.password = newPassword.trim()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PasswordMixin.js